module.exports = __webpack_public_path__ + "img/aep.dbff30e5.png";